import { Typography } from "@p0security/ui";
import { integrationOptionProvider } from "components/Integrations/utils/resourcesInstalledUtil";

import { FileTransferInstaller } from "./types";

export const fileTransferInstaller: FileTransferInstaller = {
  components: {
    "iam-write": {
      optionProvider: integrationOptionProvider("iam-write", [
        { component: "iam-write", integration: "aws", keyPrefix: "aws" },
      ]),
      items: {},
    },
  },
  preamble: (
    <>
      <Typography.Paragraph>
        Enable fast file transfers to and from EC2 instances using S3.
      </Typography.Paragraph>
      <Typography.Text strong>Prerequisites:</Typography.Text>
      <ul className="preamble-list">
        <li>SSH integration installed for the target AWS account</li>
      </ul>
    </>
  ),
};
